import { useEffect, useState } from "react";
import api from "../services/api";

// Busca as flags do formulário de gestante (US-99873). Em caso de erro a
// flag permanece desligada e a seção simplesmente não é exibida.
export const useGestanteFormConfig = () => {
  const [config, setConfig] = useState({ gender_orientation_ui_enabled: false });

  useEffect(() => {
    let ativo = true;
    api
      .get("/gestante/form-config")
      .then((response) => {
        if (ativo && response?.data) setConfig(response.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar configuração do formulário:", error);
      });
    return () => {
      ativo = false;
    };
  }, []);

  return config;
};

export default useGestanteFormConfig;
